import { createSlice } from "@reduxjs/toolkit";
import { IAIConfigurationSlice } from "../../../models/ai/IAI";


const initialAIConfigurationState: IAIConfigurationSlice = {
  apiKeyConfiguration: undefined,
  apiKeyConfigurations: undefined,
  aiAgentKey: undefined,
  aiAgentKeyLoading: true,
};

const aiConfigurationSlice = createSlice({
  name: "aiConfiguration",
  initialState: initialAIConfigurationState,
  reducers: {
    setApiConfiguration: (state, action: { payload: any }) => {
      state.apiKeyConfiguration = action.payload;
    },
    setApiConfigurations: (state, action: { payload: any }) => {
      state.apiKeyConfigurations = action.payload;
    },
    setAiAgentKey: (state, action: { payload: any }) => {
      state.aiAgentKey = action.payload;
    },
    setAiAgentKeyLoading: (state, action: { payload: boolean }) => {
      state.aiAgentKeyLoading = action.payload;
    },
  },
});

export const { setApiConfiguration, setApiConfigurations, setAiAgentKey, setAiAgentKeyLoading } = 
  aiConfigurationSlice.actions;

const aiConfigurationReducer = aiConfigurationSlice.reducer;

export type aiConfigurationState = ReturnType<typeof aiConfigurationReducer>;

export default aiConfigurationReducer;
